import * as actions from 'actions';

const INITIAL_STATE = {
  emojis: []
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.JOURNAL_EMOJIS_FETCH_SUCCESS: {
      return {
        ...state,
        emojis: action.result
      };
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/journal/emojis/reducer.js
 **/